module.exports = __webpack_public_path__ + "static/media/foxy.618aad28.png";